import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController } from 'ionic-angular';
import { Observable } from 'rxjs/Rx';
import { SubscriptionsService } from '../../services/subscriptions/subscriptions-service';

@IonicPage()
@Component({
  selector: 'page-pricing',
  templateUrl: 'pricing.html',
})
export class PricingPage {
  public Plans: Array<any>;

  ionViewCanEnter() {
    let self: PricingPage = this;
    return new Promise((resolve, reject) => {
      self.loadPricing().subscribe(
        res => {resolve(null)},
        rej => {resolve(null)}
      )
    });
  }

  loadPricing() {
    let self: PricingPage = this;
    return Observable.create(observable => {
      self.subscriptionsService.pricing()
        .subscribe(
          res => {
            self.Plans = res;
            observable.next();
          },
          rej => {
            let toast = self.toastCtrl.create({ message: rej.error.message, duration: 9000, position: "top"});
            toast.present();
            observable.next();
          },
        );
    });
  }

  constructor( public navCtrl: NavController,
    public navParams: NavParams,
    private toastCtrl: ToastController,
    private subscriptionsService: SubscriptionsService) {}

}



// WEBPACK FOOTER //
// ./src/pages/pricing/pricing.ts